import type { ApiModuleEndpoints } from '../types'

export const shiftClosingReportApiEndpoints = {
  report: { method: 'GET', path: '/reports/shift-closing', requiresAuth: true },
  pendingHandovers: {
    method: 'GET',
    path: '/reports/shift-closing/pending-handovers',
    requiresAuth: true,
  },
  handoverContext: {
    method: 'GET',
    path: '/reports/shift-closing/pending-handovers/:id/context',
    requiresAuth: true,
  },
  aggregates: { method: 'GET', path: '/reports/shift-closing/aggregates', requiresAuth: true },
  aggregateDetail: {
    method: 'GET',
    path: '/reports/shift-closing/aggregates/:id',
    requiresAuth: true,
  },
  detail: { method: 'GET', path: '/reports/shift-closing/:id', requiresAuth: true },
  submit: { method: 'POST', path: '/reports/shift-closing', requiresAuth: true },
  approve: { method: 'POST', path: '/reports/shift-closing/:id/approve', requiresAuth: true },
  reject: { method: 'POST', path: '/reports/shift-closing/:id/reject', requiresAuth: true },
  acceptHandover: {
    method: 'POST',
    path: '/reports/shift-closing/:id/accept-handover',
    requiresAuth: true,
  },
  export: { method: 'GET', path: '/reports/shift-closing/export', requiresAuth: true },
  dayClosingList: { method: 'GET', path: '/reports/day-closing', requiresAuth: true },
  dayClosingPreview: { method: 'GET', path: '/reports/day-closing/preview', requiresAuth: true },
  dayClosingSubmit: { method: 'POST', path: '/reports/day-closing', requiresAuth: true },
  dayClosingDetail: { method: 'GET', path: '/reports/day-closing/:id', requiresAuth: true },
  dayClosingApprove: {
    method: 'POST',
    path: '/reports/day-closing/:id/approve',
    requiresAuth: true,
  },
  dayClosingReject: {
    method: 'POST',
    path: '/reports/day-closing/:id/reject',
    requiresAuth: true,
  },
  dayClosingReopen: {
    method: 'POST',
    path: '/reports/day-closing/:id/reopen',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
